// extracted by mini-css-extract-plugin
export var description = "achievement-module--description--5891f";
export var education = "achievement-module--education--760a7";